import { Plugin } from '../plugin';

export class CameraVFXItemLoader extends Plugin {
}
